import { Module } from 'wrapper6';

export default class RentalModal extends Module {
    ready() {
        this.TRIGGERS = document.querySelectorAll('[data-rental-modal]');
        this.MODAL = document.querySelector('[data-mtt-modal-id="rental"]');

        if (this.TRIGGERS.length && this.MODAL) {
            for (let i = 0; i < this.TRIGGERS.length; i++) {
                const TRIGGER = this.TRIGGERS[i];

                TRIGGER.addEventListener('click', event => {
                    const PARENT_BOX = TRIGGER.parentNode.parentNode;
                    const TITLE = PARENT_BOX.querySelector('.title');
                    const HIDDEN_FIELD = this.MODAL.querySelector('.rental-topic');

                    HIDDEN_FIELD.value = TITLE.innerText;
                });
            }
        }
    }
}